export default __webpack_public_path__ + "9e1220b7d98f02444bce583a09d6b86a.png";